/**
 * 校验权限
 * @param code
 * @returns {*}
 */
export function authorization(code) {
    let permissionList = JSON.parse(sessionStorage.getItem("permissionList"));
    if (!permissionList || !Array.isArray(permissionList)) {
        return false;
    }
    let permission = permissionList.find((x) => { return x.code == code; });
    return permission?.id > 0;
}